import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SAUTableModule } from '@some-angular-utils/table';
import { Urls } from '@/apiConnection/urls';
import { ApiService } from '@/apiConnection/ApiService';

@Component({
  imports: [
    SAUTableModule,
  ],
  templateUrl: './activity-log-list.page.html',
  styleUrl: './activity-log-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class ActivityLogListPage {

  @ViewChild('sauTable')
  sauTable: { refresh: () => void; } | undefined;

  public url = Urls.urls.activityLogs;

  public headers = [
    { name: 'Fecha', key: 'created_at', type: 'dateTime' },
    { name: 'Usuario', key: 'user.name' },
    { name: 'Acción', key: 'action' },
    { name: 'Método', key: 'method' },
    { name: 'Ruta', key: 'path' },
    { name: 'Código', key: 'status_code' },
    { name: 'IP', key: 'ip_address' },
  ];

  public filterConfig: any = {
    orderParamName: 'sort',
    orderByFields: [
      { field: 'created_at', label: 'Fecha', defaultValue: true },
    ],
    order: ['user', 'action', 'dateRange'],
    mobile: ['user', 'dateRange'],
    form: {
      user: {
        name: 'Usuario',
        key: 'user_id',
        type: 'selectSimple',
        dropdowns: [],
      },
      action: {
        name: 'Acción',
        key: 'action',
        type: 'selectSimple',
        dropdowns: [
          { id: 'create', name: 'Crear' },
          { id: 'update', name: 'Actualizar' },
          { id: 'delete', name: 'Eliminar' },
        ],
      },
      dateRange: {
        name: 'Periodo',
        key: 'date_from',
        keyTo: 'date_to',
        type: 'dateRange',
        defaultValue: []
      },
    }
  };

  public dropdowns: any = {
    users: [],
  };

  constructor(
    private cdr: ChangeDetectorRef,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.getDropdowns();
  }

  getDropdowns() {
    const config = { users: {} };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.dropdowns.users = data.users || [];
        this.filterConfig.form.user.dropdowns.push(...data.users || []);
        this.cdr.detectChanges();
      }
    });
  }

}
